let buyXGetY = {
  running: false,
  cartItems: document.querySelector('cart-items'),
  promoMeterElement: document.querySelector('.promo-meter-wrapper'),

  init() {
    this.bindEvents();
    this.initCheck();
  },

  bindEvents() {
    let _this = this;

    let events = ['flu:cart:item-added', 'flu:cart:updated', 'flu:cart:error'];
    events.forEach(event => {
      document.addEventListener(event, (e) => {
        _this.initCheck();
      });
    })

  },

  initCheck() {
    let _this = this;

    // If running, return
    if (_this.running) {
      return;
    }

    // Set running state
    _this.running = true;

    // product add to cart
    fetch('/cart?view=verify-buyxgety').then(res => res.text()).then(response => {
      // Disable running state
      _this.running = false;

      // Check Promotions
      this.checkBuyXGetYProduct(response);
    });
  },

  addProductsToCart(variantId) {
    let _this = this;
    let skipProps = false;
    let y_quantity = 1;
    // Enable loading state
    // _this.cartItems.enableLoading();

    // Flatten the array of arrays into a single array
    let atcItems = [];

    atcItems.push({
      'id': variantId,
      'quantity': y_quantity,
      properties: skipProps ? {} : {
        '_is_bxgx_product': true
      },
    });

    // Return if no atcItems
    if (!variantId) {
      return;
    }

    // Set the formData items
    let formData = {
      'items': atcItems
    };

    // If running, return
    if (_this.running) {
      // console.warn('BuyXGetY is already running, skipping this operation.');
      return;
    }

    // Set running state
    _this.running = true;

    // Add items to cart
    fetch('/cart/add.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then(response => {
        // Sections rendering
        // _this.cartItems.renderContents(response);
        // Disable loading state
        _this.disableLoading();

        // Refresh cart
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
          location.reload();
        }
        _this.running = false;
      });
  },

  updateItemQty(id, qty = 1) {
    let _this = this;
    // Enable loading state
    _this.cartItems.enableLoading();

    fetch('/cart/change.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: qty,
        // sections: _this.cartItems.getSectionsToRender().map((section) => section.id)
      })
    })
      .then((response) => response.json())
      .then(response => {
        // Sections rendering
        // _this.cartItems.renderContents(response);
        // Disable loading state
        _this.disableLoading();

        _this.cartItems.refresh(false);

        if (document.querySelector('body').classList.contains('template-cart') || document.querySelector('body').classList.contains('shopify-checkout')) {
          location.reload();
        }
        _this.running = false;
      });
  },

  // product
  checkBuyXGetYProduct(response) {
    let _this = this;
    let data = response;

    let promoMeterElement = document.querySelector('.promo-meter-wrapper');

    // Replace promo meter
    if (promoMeterElement && response) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(response, 'text/html');
      let newPromoMeter = doc.querySelector('.promo-meter-wrapper');
      if (newPromoMeter) {
        promoMeterElement.replaceWith(newPromoMeter);
        promoMeterElement = newPromoMeter; // Update reference to the new element
      }
    }


    // Get gift product id
    let giftProductId = promoMeterElement ? promoMeterElement.getAttribute('data-gift-product-id') : null;

    let isFulfilled = promoMeterElement.querySelector('.promo-progress-bar-wrapper').getAttribute('data-is-fulfilled') ? promoMeterElement.querySelector('.promo-progress-bar-wrapper').getAttribute('data-is-fulfilled') === 'true' : false;

    let giftInCart = promoMeterElement.querySelector('.promo-progress-bar-wrapper').getAttribute('data-gift-in-cart') ? promoMeterElement.querySelector('.promo-progress-bar-wrapper').getAttribute('data-gift-in-cart') === 'true' : false;

    if (giftProductId && isFulfilled && !giftInCart) {
      // _this.addProductsToCart(giftProductId); 
    }


  },

  // Disable loading state
  disableLoading() {
    let cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    cartItems.classList.remove('pointer-events-none');
    const loader = cartItems.querySelector('.cart-item__loader');
    if (loader) loader.hidden = true;
    document.activeElement.blur();
    if (cartItems.itemStatus) cartItems.itemStatus.setAttribute('aria-hidden', 'true');
  },

}

buyXGetY.init();